import axios, { AxiosResponse } from 'axios'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export interface RefundLineItemType {
  product_name: string
  sku_number: string
  qty_refund: number
  stock: number
  product_price: number
}
export interface RefundProofType {
  id: string | number
  file_url: string
}
export interface RefundDetailType {
  refund: {
    id: string | number
    order_id: string
    status: string
    status_fmt: string
    refund_method: string
    refund_method_fmt: string
    complaint_reason_fmt: string
    notes: string
    refund_insight: string
  }
  refund_line_items: RefundLineItemType[]
  refund_proofs: RefundProofType[]
  user_level: string
  refund_proof_msg: string
}
export interface RefundRejectionReasonType {
  refund_rejection_reason_list: { reason: string }[]
}
export interface RefundComplaintReasonType {
  reason: string
  refund_complaint_reason_id: string | number
  is_text_mandatory: boolean
}

export const getRefund = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/refunds`, { params })
export const getRefundDetail = (
  data: string | number,
  params?: Record<string, unknown>,
): Promise<AxiosResponse<{ data: RefundDetailType }>> =>
  axios.get(`${baseUrl}/api/refund/${data}`, { params })
export const getRefundCriteria = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/refunds`, { params })
export const getRefundPointBalance = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/refund/points`, { params })
export const getListRefund = (
  order_id: string | number,
  params: Record<string, unknown>,
): Promise<AxiosResponse> => axios.get(`${baseUrl}/api/refund/list/${order_id}`, { params })
export const getRejectReason = (
  params?: Record<string, unknown>,
): Promise<AxiosResponse<{ data: RefundRejectionReasonType }>> =>
  axios.get(`${baseUrl}/api/refund/reject-reason`, { params })
export const getSaldoHistory = (
  customerId: string | number,
  params: Record<string, unknown>,
): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/refund/refund-point-history/${customerId}`, { params })
export const getRefundableProducts = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/refund/refundable-products`, { params })
export const getRefundComplaintReason = (): Promise<
  AxiosResponse<{ data: { refund_complaint_reason_list: RefundComplaintReasonType[] } }>
> => axios.get(`${baseUrl}/api/refund/complaint-reason`)
export const putRefund = (
  id: string | number,
  payload: Record<string, unknown>,
): Promise<AxiosResponse> => axios.put(`${baseUrl}/api/refund/${id}`, payload)
export const putUpdateRefundStatus = (
  refundId: string | number,
  payload: Record<string, unknown>,
): Promise<AxiosResponse<{ data: { message: string } }>> =>
  axios.put(`${baseUrl}/api/refund/status/${refundId}`, payload)
